export default "/assets/images/gamer-room-video-thumbnail.9a37ed4260475b84.jpg";